export default (state = null, action) =>{
    switch(action?.type){
        case 'FETCH_DATA_CHART':
        case 'EMPTY_DATA_CHART':
            return action.payload;
        case 'FETCH_DATA_CHART_LINE':
            return action.payload;
        default:
            return state;
    }
}
